const VoucherCampaignType = {
  Generic: "generic",
  Unique: "unique",
};

export default VoucherCampaignType;
